import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import { FormEvent, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { UserAvatar } from '../../../common/UserAvatar';
import { RootState } from '../../../store';
import { getMissingMembersFromGroup, getSelectedUserGroup } from '../redux/userGroupSelectors';
import { addMembersToGroup } from '../redux/userGroupSlices';

const mapStateToProps = (state: RootState) => ({
    missingMembers: getMissingMembersFromGroup(state),
    userGroup: getSelectedUserGroup(state)
});

type OwnProps = {
    closeDialog: () => void;
};
type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const AddUserGroupMemberDialog = ({ userGroup, missingMembers, closeDialog }: Props) => {
    const [selectedUserIds, setSelectedUserIds] = useState([] as number[]);

    const dispatch = useDispatch();

    if (userGroup == null) {
        return <div />;
    }

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        dispatch(
            addMembersToGroup.request({
                userGroupId: userGroup.userGroupId,
                userIds: selectedUserIds
            })
        );
        closeDialog();
    };

    const handleUserSelected = (userId: number) => {
        const exists = selectedUserIds.includes(userId);
        if (exists) {
            setSelectedUserIds(userIds => userIds.filter(uid => uid !== userId));
        } else {
            setSelectedUserIds(userIds => [...userIds, userId]);
        }
    };

    return (
        <Dialog open={true}>
            <DialogTitle>Add users to {userGroup.name}</DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <List>
                        {missingMembers.map(m => (
                            <ListItem key={m.userId} onClick={() => handleUserSelected(m.userId)}>
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={selectedUserIds.includes(m.userId)}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText primary={<UserAvatar user={m} iconOnly={false} />} />
                            </ListItem>
                        ))}
                    </List>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    type="submit"
                    disabled={selectedUserIds.length === 0}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default connect(mapStateToProps)(AddUserGroupMemberDialog);
